import { Check } from "lucide-react";
import { PortalSection } from "./portal-ui";
import { parseSupport } from "./portal-utils";

interface InvestmentDetailsCardProps {
  prize?: string;
}

/**
 * What a founder gets beyond the cheque. The cheque range itself lives in the
 * portal's summary panel, beside the dates, where it is read at a glance.
 */
export function InvestmentDetailsCard({ prize }: InvestmentDetailsCardProps) {
  const { isHtml, resources, hasResources } = parseSupport(prize);
  if (!hasResources) return null;

  let body;
  if (isHtml) {
    body = (
      <div
        className="prose max-w-[68ch] text-[15.5px] leading-[1.7] text-foreground/85 prose-p:my-3 prose-a:text-foreground prose-strong:text-foreground prose-li:my-1 prose-li:marker:text-muted-foreground/60"
        dangerouslySetInnerHTML={{ __html: prize ?? "" }}
      />
    );
  } else if (resources.length === 1) {
    body = (
      <p className="max-w-[68ch] text-[15.5px] leading-relaxed text-foreground/85">
        {resources[0]}
      </p>
    );
  } else {
    body = (
      <ul className="grid gap-x-8 gap-y-3 sm:grid-cols-2">
        {resources.map((resource, index) => (
          <li key={index} className="flex items-start gap-2.5 text-[15px]">
            <Check className="mt-1 h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <span className="leading-relaxed text-foreground/85">{resource}</span>
          </li>
        ))}
      </ul>
    );
  }

  return <PortalSection title="Beyond the cheque">{body}</PortalSection>;
}
